import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthService {
  // Signals para estado reactivo
  private _sessionId = signal<string | null>(localStorage.getItem('session_id'));
  private _token = signal<string | null>(localStorage.getItem('auth_token'));

  // Selectores públicos (Read-only)
  sessionId = computed(() => this._sessionId());
  token = computed(() => this._token());

  // La sesión es válida si tenemos al menos el ID de sesión inicial
  hasInitialSession = computed(() => !!this._sessionId());
  isAuthenticated = computed(() => !!this._token());

  saveInitialSession(id: string, token?: string) {
    localStorage.setItem('session_id', id);
    this._sessionId.set(id);

    if (token) {
      localStorage.setItem('auth_token', token);
      this._token.set(token);
    }
  }

  saveCustomerToken(token: string) {
    localStorage.setItem('auth_token', token);
    this._token.set(token);
  }

  clearCustomerToken() {
    localStorage.removeItem('auth_token');
    this._token.set(null);
  }

  logout() {
    localStorage.clear();
    this._sessionId.set(null);
    this._token.set(null);
    window.location.href = '/personas/ingreso';
  }
}
